<template>
  <a tabindex="0" :class="iconeLabelClass" v-bind="$attrs">
    <i :class="iconeClass" :style="styleItens" />
    <span
      class="lg-aa-texto-truncado--max-linhas-2 lg-aa-iconeLabel__label"
      :style="styleItens"
    >{{ label }}</span>
  </a>
</template>

<script>
export default {
  name: 'LGIconeLabel',
  props: {
    icone: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    iconePos: {
      type: String,
      default: 'esquerda',
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconeLabelClass() {
      return {
        'lg-aa-iconeLabel': true,
        'lg-aa-iconeLabel--topo': this.iconePos === 'topo',
      };
    },
    iconeClass() {
      return [
        this.icone,
        {
          'lg-aa-iconeLabel__icone': true,
          'lg-aa-iconeLabel__icone--direita': this.iconePos === 'direita',
          'lg-aa-iconeLabel--topo': this.iconePos === 'topo',
        },
      ];
    },
    styleItens() {
      if (this.color) {
        return {
          color: this.color,
        };
      }

      return {};
    },
  },
};
</script>
